module.exports = __webpack_public_path__ + "static/media/puzzle.533e4d50.svg";